export default <T extends Record<string, unknown>>(
  v: T | null,
): v is { [K in keyof T]: NonNullable<T[K]> } => v !== null && v.node !== null;
